
export const PAYRUN_OPERATION = {
  PAYRUN: 'PAYRUN',
  BULK_UPDATE: 'BULK_UPDATE'
};
